import axios from "axios";
const URL = process.env.VUE_APP_API;

export default {
  anything(data) {
    return axios.post(`${URL}/open_ai/rewrite`, data).then((res) => {
      return res.data.result;
    });
  },
  prompt(data) {
    return axios.post(`${URL}/open_ai/prompt`, data).then((res) => {
      return res.data.result;
    });
  },
  generateInsight(data) {
    return axios.post(`${URL}/open_ai/generate_insight`, data).then((res) => {
      return res.data.result;
    });
  },
};
